import Vue from "vue";
import App from "./App.vue";
import VModal from "vue-js-modal";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "@fortawesome/fontawesome-free/css/all.css";
import CripLoading from "crip-vue-loading";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import axios from "axios";
import VueAnalytics from "vue-analytics";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "../public/assets/style.css";
import "../public/assets/mobile-style.css";
import "../public/assets/simple-sidebar.css";

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.use(CripLoading, {
  axios: axios,
  color: "#5dc8b3",
  height: "5px"
});

Vue.use(VModal, {
  dialog: false,
  dynamicDefaults: {
    draggable: true,
    resizable: false,
    height: "auto"
  }
});
Vue.use(VueAnalytics, {
  id: "GTM-N3HJF69",
  router
});
Vue.config.productionTip = false;
Vue.config.devtools = true;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
